import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {RouteModel} from "../../../routes/models/route.model";

export const RoutesChannelActions = createActionGroup({
  source: '[Routes/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: RouteModel }>(),
    partialNotificationReceived: props<{ notification: RouteModel }>(),
  }
});

export const RoutesAPiActions = createActionGroup({
  source: '[Routes/API]',
  events: {

    //Get infinite scroll Routes
    getInfiniteScrollRoutes: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollRoutesSuccess: props<{ routes: RouteModel[], cursor?: string, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollRoutesFailure: props<{ error: any }>(),

    //Get Routes
    getRoutes: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getRoutesSuccess: props<{ routes: RouteModel[], isSubscribeToChannel?: boolean }>(),
    getRoutesFailure: props<{ error: any }>(),

    //Get Route
    getRoute: props<{ routeId: string, isSubscribeToChannel?: boolean }>(),
    getRouteSuccess: props<{ route: RouteModel, isSubscribeToChannel?: boolean }>(),
    getRouteFailure: props<{ error: any }>()

  },
});

export const RoutesActions = createActionGroup({
  source: '[Route]',
  events: {
    removeRoutes: props<{ ids: string[] }>(),
    removeRoute: props<{ id: string }>(),
    setRoutes: props<{ routes: RouteModel[], isAppendFirst?: boolean }>(),
    setInfiniteScrollRoutesIds: props<{ routeIds: string[], isAppendFirst?: boolean }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

